import CityPageTemplate from "../city-template/CityPageTemplate";
import { pelhamConfig } from "./data";

export default function PelhamPage() {
  return <CityPageTemplate config={pelhamConfig} />;
}